import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-470c2998"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold mb-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-5" }
const _hoisted_4 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_5 = { class: "rounded-4 overflow-hidden border-container me-4" }
const _hoisted_6 = { class: "scroll-container overflow-auto" }
const _hoisted_7 = { class: "break-word" }
const _hoisted_8 = { class: "fs-7 ps-3" }
const _hoisted_9 = { class: "fs-7 ps-2 text-break" }
const _hoisted_10 = {
  key: 0,
  class: "fs-7 ps-2 text-break"
}
const _hoisted_11 = { class: "col-xxl-7" }
const _hoisted_12 = { class: "fw-bold ps-2 fs-7 mb-3 mt-5 mt-xxl-0" }
const _hoisted_13 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_14 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-max-content col-lg-1 col-form-label" }, null, -1))
const _hoisted_16 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_17 = { class: "col-lg-12" }
const _hoisted_18 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "row mx-0 px-0 col-lg-1" }
const _hoisted_21 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_22 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_23 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_24 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_25 = { class: "col-lg-12" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_28 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom" }
const _hoisted_29 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_30 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_31 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_32 = { class: "col-lg-12" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_35 = { class: "mt-2" }
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4 border-bottom fs-7" }
const _hoisted_38 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_39 = { class: "mx-0 col-7 row" }
const _hoisted_40 = { class: "mx-0 col-12 d-flex align-items-center mb-2" }
const _hoisted_41 = { class: "d-flex input-group" }
const _hoisted_42 = ["placeholder", "value"]
const _hoisted_43 = { class: "mb-3 d-none" }
const _hoisted_44 = ["accept"]
const _hoisted_45 = {
  key: 0,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_46 = {
  key: 1,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_47 = {
  key: 2,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_48 = {
  key: 3,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_49 = {
  key: 4,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_50 = { class: "mx-0 col-12 d-flex align-items-center mb-2" }
const _hoisted_51 = { class: "d-flex input-group" }
const _hoisted_52 = ["placeholder", "value"]
const _hoisted_53 = { class: "mb-3 d-none" }
const _hoisted_54 = ["accept"]
const _hoisted_55 = {
  key: 5,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_56 = {
  key: 6,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_57 = {
  key: 7,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_58 = {
  key: 8,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_59 = {
  key: 9,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_60 = { class: "mx-0 col-12 d-flex align-items-center mb-2" }
const _hoisted_61 = { class: "d-flex input-group" }
const _hoisted_62 = ["placeholder", "value"]
const _hoisted_63 = { class: "mb-3 d-none" }
const _hoisted_64 = ["accept"]
const _hoisted_65 = {
  key: 10,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_66 = {
  key: 11,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_67 = {
  key: 12,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_68 = {
  key: 13,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_69 = {
  key: 14,
  class: "fs-8 invalid-error mb-2"
}
const _hoisted_70 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_71 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_72 = { class: "row mx-0 px-0 col-lg-7 mt-2" }
const _hoisted_73 = { class: "form-check ms-3" }
const _hoisted_74 = {
  class: "form-check-label",
  for: "flexRadioDefault1"
}
const _hoisted_75 = { class: "form-check ms-3" }
const _hoisted_76 = {
  class: "form-check-label",
  for: "flexRadioDefault2"
}
const _hoisted_77 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_78 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_79 = { class: "row mx-0 px-0 col-lg-8 mt-2" }
const _hoisted_80 = { class: "form-check ms-3" }
const _hoisted_81 = {
  class: "form-check-label",
  for: "immediate"
}
const _hoisted_82 = { class: "form-check ms-3" }
const _hoisted_83 = {
  class: "form-check-label",
  for: "flexRadioDefault3"
}
const _hoisted_84 = { class: "row mx-0 px-0 col-lg-5" }
const _hoisted_85 = { class: "col-lg-12" }
const _hoisted_86 = { class: "input-group mb-2" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_88 = { class: "col-lg-6 ms-3 px-0" }
const _hoisted_89 = { class: "d-flex" }
const _hoisted_90 = {
  key: 0,
  class: "form-select fs-7",
  "aria-label": "Default select example",
  disabled: ""
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, null, -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = ["value"]
const _hoisted_94 = { class: "px-3 d-flex align-items-center" }
const _hoisted_95 = {
  key: 2,
  class: "form-select fs-7",
  "aria-label": "Default select example minutes",
  disabled: ""
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, null, -1))
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = ["value"]
const _hoisted_99 = { class: "ps-3 d-flex align-items-center" }
const _hoisted_100 = { class: "invalid-error ms-2" }
const _hoisted_101 = { class: "mt-2 mx-2" }
const _hoisted_102 = { class: "mx-2" }
const _hoisted_103 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_104 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_105 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_106 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_107 = { class: "modal-dialog modal-xl" }
const _hoisted_108 = { class: "modal-content" }
const _hoisted_109 = { class: "modal-header" }
const _hoisted_110 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_112 = { class: "row p-3" }
const _hoisted_113 = { class: "col-xxl-5" }
const _hoisted_114 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_115 = { class: "rounded-4 overflow-hidden border-container me-4" }
const _hoisted_116 = { class: "scroll-container overflow-auto" }
const _hoisted_117 = { class: "break-word" }
const _hoisted_118 = { class: "fs-7 ps-3" }
const _hoisted_119 = { class: "fs-7 ps-2 text-break" }
const _hoisted_120 = {
  key: 0,
  class: "fs-7 ps-2 text-break"
}
const _hoisted_121 = { class: "col-xxl-7" }
const _hoisted_122 = { class: "fw-bold ps-2 fs-7 mb-3 mt-5 mt-xxl-0" }
const _hoisted_123 = { class: "border-bottom row mx-0 px-0 gx-3 my-4 pb-4" }
const _hoisted_124 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_125 = { class: "row mx-0 px-0 col-lg-9 fs-7 pt-2 text-break" }
const _hoisted_126 = { class: "border-bottom row mx-0 px-0 gx-3 pb-4 mb-4" }
const _hoisted_127 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_128 = { class: "row mx-0 px-0 col-lg-9 fs-7 flex justify-content align-items-center text-break break-spaces" }
const _hoisted_129 = ["innerHTML"]
const _hoisted_130 = { class: "row mx-0 px-0 gx-3 pb-4" }
const _hoisted_131 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_132 = { class: "row mx-0 px-0 col-lg-9 fs-7 pt-2 text-break" }
const _hoisted_133 = { class: "border-bottom row mx-0 px-0 gx-3 pb-4 mb-4 pt-4 border-top" }
const _hoisted_134 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_135 = { class: "row mx-0 px-0 col-lg-9 fs-7 flex justify-content align-items-center" }
const _hoisted_136 = { class: "row mx-0 px-0 gx-3 pb-4 border-bottom" }
const _hoisted_137 = { class: "w-max-content col-lg-3 col-form-label fs-7" }
const _hoisted_138 = { class: "mx-0 px-0 col-lg-9 fs-7 d-flex justify-content align-items-center" }
const _hoisted_139 = { class: "py-4 d-flex justify-content-center fs-7 fw-bold modal-footer" }
const _hoisted_140 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_141 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_142 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_143 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_144 = {
  class: "modal fade",
  id: "modalFinish",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_145 = { class: "modal-dialog" }
const _hoisted_146 = { class: "modal-content" }
const _hoisted_147 = { class: "modal-header" }
const _hoisted_148 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = { class: "bg-light py-3 ps-3 pe-2 m-4" }
const _hoisted_151 = { class: "me-2" }
const _hoisted_152 = /*#__PURE__*/_createTextVNode()
const _hoisted_153 = { class: "text-center m-4" }
const _hoisted_154 = { class: "modal-footer d-flex justify-content-center" }

import { ref, watch, computed, onMounted, nextTick } from 'vue'
import { MAX_UPLOAD_FILE_SIZE_BYTES, MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_FILE_NAME_LENGTH } from '@/constants/number'
import { numberWithCommas } from '@/constants/common.ts'
import Button from '@/components/button/index.vue'
import Status from '@/components/status/index.vue'
import messageTemplateServices from '@/services/message-template.services'
import { useRoute, useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import { COMMUNITY_ALUMNUS_STORE, COMMUNITY_USERS_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { blobDownload, customMaxLength, scrollToErrors, purifyContent } from '@/utils'
import flatPickr from 'vue-flatpickr-component'
import { HOURS, MINUTES } from '@/constants/regex'
import { configMinDate } from '@/constants/datepicker'
import dayjs from 'dayjs'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { debounce, pick } from 'lodash'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { ConvertFromUTCTime } from '@/constants/datepicker.ts'
import { Modal } from 'bootstrap'
import { REGEX_EMOJI } from '@/constants/regex'
import commonService from '@/services/common.service'
import { buildFormData, buildImgUrl } from '@/utils'
import { messageAttachedFileExtensions, messageAttachedFileFormats } from '@/constants/upload-type'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

const route = useRoute()
const router = useRouter()
const fileName1 = ref('')
const fileName2 = ref('')
const fileName3 = ref('')
const fileType1 = ref<string | null>(null)
const fileType2 = ref<string | null>(null)
const fileType3 = ref<string | null>(null)
const fileData1 = ref(null)
const fileData2 = ref(null)
const fileData3 = ref(null)
const file1 = ref(null)
const file2 = ref(null)
const file3 = ref(null)
const fileUrl1 = ref(null)
const fileUrl2 = ref(null)
const fileUrl3 = ref(null)
const ClickSubmit = ref<boolean>(false)
const checkExist = ref<boolean>(true)
const errorMaxUpload = ref<boolean>(false)
const dataMessageTemplate = ref([])
const store = useStore()
const dataReturn = ref([])
const validateTime = ref<boolean>(false)
const listRecordSelected = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_RECORD_SELECTED])
const modal = ref()
const loadingSend = ref(false)
const errorFileFormatUpload = ref<boolean>(false)
const error404 = ref<boolean>(false)
const buttonModalFinishTitle = computed(() => {
  if (hanldeErrorServer.value) return translate('close')
  return translate(route?.query?.user_type === '2' ? 'OE50toAlumni' : 'OE50toEmployee')
})

onMounted(() => {
  modal.value = new Modal(document.getElementById('modalConfirm'))
  const documentModalFinish = document.getElementById('modalFinish')
  modalFinish.value = new Modal(documentModalFinish)
  documentModalFinish?.addEventListener('hidden.bs.modal', resetError)
})

const modalFinish = ref()
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('OE30userManagement'),
    to: ``,
    active: false,
  },
  {
    content: route.query?.user_type === '2' ? translate('OE50breadcrumbAlumnus') : translate('OE80userList'),
    to:
      route.query?.user_type === '2'
        ? `/community/communities/${route.params?.id}/alumnus?management_no=desc`
        : `/community/communities/${route.params?.id}/community-users?management_no=desc`,
    active: false,
  },
  {
    content: translate('OE50sendAllMessages'),
    to: '',
    active: true,
  },
]

const formData = ref({
  community_message_template_id: '',
  title: '',
  content: '',
  file_1: '',
  file_2: '',
  file_3: '',
  destination: 0,
  sendReservation: 0,
  booking_date: new Date(),
  hours: '00',
  minutes: '00',
})

const fileNameLengthValidation = (value) => {
  if (value) {
    const fileName = value.name
    console.log(fileName)
    console.log('fileName.length <= MAX_UPLOAD_FILE_NAME_LENGTH', fileName.length <= MAX_UPLOAD_FILE_NAME_LENGTH)
    return fileName.length <= MAX_UPLOAD_FILE_NAME_LENGTH
  }
  return true
}

const rules = computed(() => {
  return {
    title: {
      required,
      maxLength: (value: string) => customMaxLength(value, 70),
      minLength: minLength(1),
      pictograms: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    content: {
      required,
      maxLength: (value: string) => customMaxLength(value, 2000),
      minLength: minLength(1),
      pictograms: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    file_1: {
      fileTypeValidation: (value) => {
        if (value) {
          const extension = '.' + value.name.split('.').pop()
          return messageAttachedFileExtensions.includes(extension)
        }
        return true
      },
      fileSizeValidation: function (value) {
        if (value) {
          const fileSizeTotal = (fileData1.value?.size ?? 0) + (fileData2.value?.size ?? 0) + (fileData3.value?.size ?? 0)
          return fileSizeTotal <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
      fileNameLengthValidation: fileNameLengthValidation,
    },
    file_2: {
      fileTypeValidation: (value) => {
        if (value) {
          const extension = '.' + value.name.split('.').pop()
          return messageAttachedFileExtensions.includes(extension)
        }
        return true
      },
      fileSizeValidation: function (value) {
        if (value) {
          const fileSizeTotal = (fileData1.value?.size ?? 0) + (fileData2.value?.size ?? 0) + (fileData3.value?.size ?? 0)
          return fileSizeTotal <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
      fileNameLengthValidation: fileNameLengthValidation,
    },
    file_3: {
      fileTypeValidation: (value) => {
        if (value) {
          const extension = '.' + value.name.split('.').pop()
          return messageAttachedFileExtensions.includes(extension)
        }
        return true
      },
      fileSizeValidation: function (value) {
        if (value) {
          const fileSizeTotal = (fileData1.value?.size ?? 0) + (fileData2.value?.size ?? 0) + (fileData3.value?.size ?? 0)
          return fileSizeTotal <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
      fileNameLengthValidation: fileNameLengthValidation,
    },
    booking_date: {
      requiredDate: function (value) {
        if (value) return true
      },
      pastDate: function (value) {
        const date = dayjs(new Date()).format('YYYY-MM-DD')
        if (!dayjs(value).isBefore(dayjs(date))) return true
      },
    },
  }
})
const v$ = useVuelidate(rules, formData)

onMounted(() => {
  if (listRecordSelected.value?.length === 0) {
    if (route?.query?.user_type === '2') {
      router.push(`/community/communities/${route.params?.id}/alumnus?management_no=desc`)
    } else {
      router.push(`/community/communities/${route.params?.id}/community-users?management_no=desc`)
    }
  }
})
watch(
  () => route.query,
  async () => {
    try {
      const res = await messageTemplateServices.getMessageTemplates(route.params.id)
      if (res.data?.success) {
        dataMessageTemplate.value = res?.data
      }
    } catch (error) {
      console.log(error)
    }
  },
  {
    immediate: true,
  }
)

watch(
  () => formData.value.sendReservation,
  () => {
    if (formData.value.sendReservation !== '1') {
      // set default booking_date value
      formData.value.booking_date = new Date()
      formData.value.hours = '00'
      formData.value.minutes = '00'
      validateTime.value = false
    }
  }
)

const handleChangeFile1 = async () => {
  if (file1.value.files[0]) {
    const { newFileUrl, newFile } = await buildImgUrl(file1.value.files[0])
    fileUrl1.value = newFileUrl

    fileData1.value = newFile

    fileType1.value = newFile?.type
    fileName1.value = newFile?.name
    formData.value.file_1 = file1.value.files[0]
    v$.value.file_1.$touch()
    v$.value.file_2.$touch()
    v$.value.file_3.$touch()
  }
}

const handleChangeFile2 = async () => {
  if (file2.value.files[0]) {
    const { newFileUrl, newFile } = await buildImgUrl(file2.value.files[0])
    fileUrl2.value = newFileUrl

    fileData2.value = newFile

    fileType2.value = newFile?.type
    fileName2.value = newFile?.name
    formData.value.file_2 = file2.value.files[0]
    v$.value.file_1.$touch()
    v$.value.file_2.$touch()
    v$.value.file_3.$touch()
  }
}

const handleChangeFile3 = async () => {
  if (file3.value.files[0]) {
    const { newFileUrl, newFile } = await buildImgUrl(file3.value.files[0])
    fileUrl3.value = newFileUrl

    fileData3.value = newFile

    fileType3.value = newFile?.type
    fileName3.value = newFile?.name
    formData.value.file_3 = file3.value.files[0]
    v$.value.file_1.$touch()
    v$.value.file_2.$touch()
    v$.value.file_3.$touch()
  }
}

const ClearChoose1 = () => {
  fileName1.value = ''
  fileType1.value = null
  fileData1.value = null
  v$.value.file_1.$model = null
  v$.value.file_1.$touch()
  v$.value.file_2.$touch()
  v$.value.file_3.$touch()
}
const ClearChoose2 = () => {
  fileName2.value = ''
  fileType2.value = null
  fileData2.value = null
  v$.value.file_2.$model = null
  v$.value.file_1.$touch()
  v$.value.file_2.$touch()
  v$.value.file_3.$touch()
}
const ClearChoose3 = () => {
  fileName3.value = ''
  fileType3.value = null
  fileData3.value = null
  v$.value.file_3.$model = null
  v$.value.file_1.$touch()
  v$.value.file_2.$touch()
  v$.value.file_3.$touch()
}

const FillData = () => {
  if (formData.value.community_message_template_id) {
    formData.value.title = dataMessageTemplate.value?.data.find((e) => e.id === formData.value.community_message_template_id)?.title
    formData.value.content = dataMessageTemplate.value?.data.find((e) => e.id === formData.value.community_message_template_id)?.content
  }
}

const clickFile = (data: File | any, fileName: string) => {
  const blob = new Blob([data], { type: data.type })
  blobDownload(blob, fileName)
}

const BackPreviousPage = () => {
  // 2022/11/02 TienNV Fix bug selected user disappears when back previous page  UAT#4500: OE50(Ph2-R20221104)
  const payload = {
    typeData: route?.query?.user_type === '2' ? 'alumni' : 'employee',
    type: 'checkAll',
    data: listRecordSelected.value,
  }
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, payload)
  router.go(-1)
}
const typeInTextarea = (newText, el = document.getElementById('content')) => {
  const start = el.selectionStart
  const end = el.selectionEnd
  const text = el.value
  const before = text.substring(0, start)
  const after = text.substring(end, text.length)
  el.value = before + newText + after
  formData.value.content = before + newText + after
  el.selectionStart = el.selectionEnd = start + newText.length

  // trigger event input to validate and show errors after change input value
  el.dispatchEvent(new Event('input'))
  el.focus()
}

const formatContent = (content: string) => {
  if (!content) return ''
  let escaped = purifyContent(content)

  escaped = escaped.replace(/#姓#/g, '<span class="active fw-bold">#姓#</span>')
  escaped = escaped.replace(/#名#/g, '<span class="active fw-bold">#名#</span>')
  return escaped
}

const renderName = (management_no: string) => {
  const data = listRecordSelected.value?.find((e) => e.management_no === management_no)
  return data.family_name + ' ' + data.given_name + ' ' + data.display_name
}
const hanldeErrorServer = ref(false)

const SubmitTemplate = async (): void => {
  loadingSend.value = true
  const data = {
    ...pick(formData.value, 'community_message_template_id', 'title', 'content'),
    file_1: fileData1.value,
    file_2: fileData2.value,
    file_3: fileData3.value,
    send_mail: Number(formData.value.destination) === 1 ? true : false,
    booking_date:
      Number(formData.value.sendReservation) === 1
        ? ConvertFromUTCTime(dayjs(formData.value.booking_date).format('YYYY/MM/DD') + ' ' + formData.value.hours + ':' + formData.value.minutes).format()
        : '',
    user_type: route?.query?.user_type === '1' ? 'employee' : 'alumni',
    community_id: route.params.id,
  }
  try {
    const newGroupMessage = new FormData()
    buildFormData(newGroupMessage, data)
    listRecordSelected?.value?.forEach((e) => {
      newGroupMessage.append('management_no[]', e.management_no)
    })

    const response = await messageTemplateServices.postGroupMessages(newGroupMessage)
    dataReturn.value = response?.data?.data
    hanldeErrorServer.value = !(response.status === 200)
  } catch (error) {
    console.log(error)
    hanldeErrorServer.value = true
  } finally {
    loadingSend.value = false
    modalFinish.value.show()
    modal.value.hide()
  }
}

const transitToSelect = () => {
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'clearData', data: [] })
  if (route?.query?.user_type === '2') {
    store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_DATA_SEARCH_ALUMNUS, [])
    router.push(`/community/communities/${route.params?.id}/alumnus?management_no=desc`)
  } else {
    store.dispatch(COMMUNITY_USERS_STORE.ACTIONS.SET_DATA_SEARCH, [])
    router.push(`/community/communities/${route.params?.id}/community-users?management_no=desc`)
  }
}

const CheckTime = () => {
  if (formData.value.sendReservation === '1') {
    const date = dayjs(new Date())

    const minute = date.diff(dayjs(dayjs(formData.value.booking_date).format('YYYY/MM/DD') + ' ' + formData.value.hours + ':' + formData.value.minutes), 'minute')
    if (minute > -10) {
      validateTime.value = true
    } else {
      validateTime.value = false
    }
  }
}
const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  CheckTime()

  isCheckedNGKeyTitle.value = false
  isCheckedNGContent.value = false
  await checkNGTitle()
  await checkNGContent()
  while (!isCheckedNGKeyTitle.value || !isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyTitle.value || ngKeyContent.value || validateTime.value) {
    nextTick(() => {
      const elementErrors = document.querySelector('.invalid-feedback')
      const classErrors = elementErrors ? '.invalid-feedback' : '.invalid-error'
      scrollToErrors(classErrors)
    })
    return
  }

  modal.value?.show()
}

const isCheckedNGKeyTitle = { value: false }
const ngKeyTitle = ref<boolean>(false)
const checkNGTitle = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.title.$model })
  ngKeyTitle.value = data.data?.data?.has_ngword
  isCheckedNGKeyTitle.value = true
}, 200)

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)

const handleModalFinishButton = () => {
  modalFinish.value.hide()
  if (hanldeErrorServer.value) return
  transitToSelect()
}

const resetError = () => {
  setTimeout(() => {
    hanldeErrorServer.value = false
    dataReturn.value = []
  }, 150)
}
const bookingDateInvalid = computed(() => validateTime.value || v$.value.booking_date.$error)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("form", {
      onSubmit: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["prevent"])),
      class: "bg-white rounded-4 shadow p-4 mb-4"
    }, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(translate)('OE50sendAllMessages')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)) + "件のユーザを選択中", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listRecordSelected), (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: user,
                  class: "d-flex px-3 py-2 display_management"
                }, [
                  _createVNode(UserAliasIcon, {
                    userType: user?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(user.management_no), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(user.family_name) + " " + _toDisplayString(user.given_name), 1),
                    (_unref(route)?.query?.user_type !== '1')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(user.display_name) + ")", 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(translate)('OE50messageContent')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('OE50sample')), 1),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "aria-label": "Default select example",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.community_message_template_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_18, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataMessageTemplate.value?.data, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      value: item?.id
                    }, _toDisplayString(item?.name), 9, _hoisted_19))
                  }), 128))
                ], 512), [
                  [_vModelSelect, formData.value.community_message_template_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass([
                'button-select shadow fw-bold cursor-pointer d-flex justify-content-center align-items-center',
                formData.value.community_message_template_id === '' ? 'disable-button' : '',
              ]),
                onClick: FillData
              }, _toDisplayString(_unref(translate)('OE50application')), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(translate)('title')), 1),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "content",
                  name: "title",
                  class: _normalizeClass(['form-control', ngKeyTitle.value || _unref(v$).title.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                  placeholder: _unref(translate)('placeholder'),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(checkNGTitle) && _unref(checkNGTitle)(...args)))
                }, null, 42, _hoisted_26), [
                  [
                    _vModelText,
                    _unref(v$).title.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyTitle.value && !_unref(v$).title.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('title'),
                  params: [1, 70],
                  validator: _unref(v$).title.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('content')), 1),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("textarea", {
                  id: "content",
                  name: "content",
                  class: _normalizeClass(['form-control', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                  rows: "10",
                  placeholder: _unref(translate)('placeholder'),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
                }, null, 42, _hoisted_33), [
                  [_vModelText, _unref(v$).content.$model]
                ]),
                (ngKeyContent.value && !_unref(v$).content.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('content'),
                  params: [1, 2000],
                  validator: _unref(v$).content.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ]),
              _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(translate)('CE10textarea2')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(translate)('CE10textarea3')), 1),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", {
                  class: "tag fs-8 d-flex align-items-center justify-content-center cursor-pointer bg-white",
                  onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (typeInTextarea('#姓#')), ["prevent"]))
                }, "#" + _toDisplayString(_unref(translate)('surName')) + "#", 33),
                _createElementVNode("div", {
                  class: "tag ms-2 fs-8 d-flex align-items-center justify-content-center cursor-pointer",
                  onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (typeInTextarea('#名#')), ["prevent"]))
                }, "#" + _toDisplayString(_unref(translate)('name')) + "#", 33)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)('OE65attachingFile')), 1),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (file1.value.click())),
                    class: "input-group-text cursor-pointer"
                  }, _toDisplayString(_unref(translate)('selectFile')), 1),
                  _createElementVNode("input", {
                    type: "text",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (file1.value.click())),
                    class: _normalizeClass([
                    'form-control fs-7',
                    !_unref(messageAttachedFileFormats).includes(fileType1.value) && fileName1.value ? 'is-invalid' : '',
                    !fileName1.value && ClickSubmit.value && checkExist.value ? 'is-invalid' : '',
                    errorFileFormatUpload.value || errorMaxUpload.value || error404.value ? 'is-invalid' : '',
                    ['fileSizeValidation', 'fileTypeValidation'].includes(_unref(v$)?.file_1?.$errors[0]?.$validator) ? 'is-invalid' : '',
                  ]),
                    id: "fileUrl1",
                    placeholder: _unref(translate)('notSelected'),
                    value: fileName1.value,
                    readonly: ""
                  }, null, 10, _hoisted_42),
                  _createElementVNode("span", {
                    onClick: ClearChoose1,
                    class: "input-group-text bg-white cursor-pointer"
                  }, _toDisplayString(_unref(translate)('ST50cancelFile')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("input", {
                  type: "file",
                  class: "mb-3 d-none",
                  id: "img",
                  name: "file_1",
                  accept: _unref(messageAttachedFileFormats).join(', ') + _unref(messageAttachedFileExtensions).join(', '),
                  onClick: _cache[9] || (_cache[9] = 
                  (event) => {
                    event.target.value = null
                  }
                ),
                  ref: (_value, _refs) => {
                    _refs['file1'] = _value
                    file1.value = _value
                  },
                  onChange: handleChangeFile1
                }, null, 40, _hoisted_44)
              ]),
              (_unref(v$)?.file_1?.$errors[0]?.$validator === 'fileSizeValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
                : _createCommentVNode("", true),
              (_unref(v$)?.file_1?.$errors[0]?.$validator === 'fileTypeValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_unref(translate)('VALIDATE_FILE_EXTENSION')), 1))
                : _createCommentVNode("", true),
              (_unref(v$)?.file_1?.$errors[0]?.$validator === 'fileNameLengthValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_unref(translate)('VALIDATE_MAX_FILE_SIZE', '', [_unref(MAX_UPLOAD_FILE_NAME_LENGTH)])), 1))
                : _createCommentVNode("", true),
              (fileName1.value === '' && ClickSubmit.value && checkExist.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_unref(translate)('OE80required')), 1))
                : _createCommentVNode("", true),
              (error404.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_49, "アップロード失敗しました。"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (file2.value.click())),
                    class: "input-group-text cursor-pointer"
                  }, _toDisplayString(_unref(translate)('selectFile')), 1),
                  _createElementVNode("input", {
                    type: "text",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (file2.value.click())),
                    class: _normalizeClass([
                    'form-control fs-7',
                    !_unref(messageAttachedFileFormats).includes(fileType2.value) && fileName2.value ? 'is-invalid' : '',
                    !fileName2.value && ClickSubmit.value && checkExist.value ? 'is-invalid' : '',
                    errorFileFormatUpload.value || errorMaxUpload.value || error404.value ? 'is-invalid' : '',
                    ['fileSizeValidation', 'fileTypeValidation'].includes(_unref(v$)?.file_2?.$errors[0]?.$validator) ? 'is-invalid' : '',
                  ]),
                    id: "fileUrl2",
                    placeholder: _unref(translate)('notSelected'),
                    value: fileName2.value,
                    readonly: ""
                  }, null, 10, _hoisted_52),
                  _createElementVNode("span", {
                    onClick: ClearChoose2,
                    class: "input-group-text bg-white cursor-pointer"
                  }, _toDisplayString(_unref(translate)('ST50cancelFile')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("input", {
                  type: "file",
                  class: "mb-3 d-none",
                  id: "img",
                  name: "file_2",
                  accept: _unref(messageAttachedFileFormats).join(', ') + _unref(messageAttachedFileExtensions).join(', '),
                  onClick: _cache[12] || (_cache[12] = 
                  (event) => {
                    event.target.value = null
                  }
                ),
                  ref: (_value, _refs) => {
                    _refs['file2'] = _value
                    file2.value = _value
                  },
                  onChange: handleChangeFile2
                }, null, 40, _hoisted_54)
              ]),
              (_unref(v$)?.file_2?.$errors[0]?.$validator === 'fileSizeValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
                : _createCommentVNode("", true),
              (_unref(v$)?.file_2?.$errors[0]?.$validator === 'fileTypeValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_unref(translate)('VALIDATE_FILE_EXTENSION')), 1))
                : _createCommentVNode("", true),
              (_unref(v$)?.file_2?.$errors[0]?.$validator === 'fileNameLengthValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(_unref(translate)('VALIDATE_MAX_FILE_SIZE', '', [_unref(MAX_UPLOAD_FILE_NAME_LENGTH)])), 1))
                : _createCommentVNode("", true),
              (fileName2.value === '' && ClickSubmit.value && checkExist.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(_unref(translate)('OE80required')), 1))
                : _createCommentVNode("", true),
              (error404.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_59, "アップロード失敗しました。"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("span", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (file3.value.click())),
                    class: "input-group-text cursor-pointer"
                  }, _toDisplayString(_unref(translate)('selectFile')), 1),
                  _createElementVNode("input", {
                    type: "text",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (file3.value.click())),
                    class: _normalizeClass([
                    'form-control fs-7',
                    !_unref(messageAttachedFileFormats).includes(fileType3.value) && fileName3.value ? 'is-invalid' : '',
                    !fileName3.value && ClickSubmit.value && checkExist.value ? 'is-invalid' : '',
                    errorFileFormatUpload.value || errorMaxUpload.value || error404.value ? 'is-invalid' : '',
                    ['fileSizeValidation', 'fileTypeValidation'].includes(_unref(v$)?.file_3?.$errors[0]?.$validator) ? 'is-invalid' : '',
                  ]),
                    id: "fileUrl3",
                    placeholder: _unref(translate)('notSelected'),
                    value: fileName3.value,
                    readonly: ""
                  }, null, 10, _hoisted_62),
                  _createElementVNode("span", {
                    onClick: ClearChoose3,
                    class: "input-group-text bg-white cursor-pointer"
                  }, _toDisplayString(_unref(translate)('ST50cancelFile')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("input", {
                  type: "file",
                  class: "mb-3 d-none",
                  id: "img",
                  name: "file_3",
                  accept: _unref(messageAttachedFileFormats).join(', ') + _unref(messageAttachedFileExtensions).join(', '),
                  onClick: _cache[15] || (_cache[15] = 
                  (event) => {
                    event.target.value = null
                  }
                ),
                  ref: (_value, _refs) => {
                    _refs['file3'] = _value
                    file3.value = _value
                  },
                  onChange: handleChangeFile3
                }, null, 40, _hoisted_64)
              ]),
              (_unref(v$)?.file_3?.$errors[0]?.$validator === 'fileSizeValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
                : _createCommentVNode("", true),
              (_unref(v$)?.file_3?.$errors[0]?.$validator === 'fileTypeValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(_unref(translate)('VALIDATE_FILE_EXTENSION')), 1))
                : _createCommentVNode("", true),
              (_unref(v$)?.file_3?.$errors[0]?.$validator === 'fileNameLengthValidation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(_unref(translate)('VALIDATE_MAX_FILE_SIZE', '', [_unref(MAX_UPLOAD_FILE_NAME_LENGTH)])), 1))
                : _createCommentVNode("", true),
              (fileName3.value === '' && ClickSubmit.value && checkExist.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(_unref(translate)('OE80required')), 1))
                : _createCommentVNode("", true),
              (error404.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_69, "アップロード失敗しました。"))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_unref(translate)('CE10textarea4')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(translate)('OE65sendMail')), 1),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("label", _hoisted_74, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault1",
                    id: "flexRadioDefault1",
                    value: "0",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.destination) = $event))
                  }, null, 512), [
                    [_vModelRadio, formData.value.destination]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50personal')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("label", _hoisted_76, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault2",
                    id: "flexRadioDefault2",
                    value: "1",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.destination) = $event))
                  }, null, 512), [
                    [_vModelRadio, formData.value.destination]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50personalEmail')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("label", _hoisted_78, _toDisplayString(_unref(translate)('OE50sendReservation')), 1),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("label", _hoisted_81, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault",
                    id: "immediate",
                    value: "0",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.sendReservation) = $event))
                  }, null, 512), [
                    [_vModelRadio, formData.value.sendReservation]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50immediate')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("label", _hoisted_83, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "flexRadioDefault3",
                    id: "flexRadioDefault3",
                    value: "1",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.sendReservation) = $event))
                  }, null, 512), [
                    [_vModelRadio, formData.value.sendReservation]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('OE50specify')), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['input-group mt-4', Number(formData.value.sendReservation) === 0 ? 'display' : ''])
              }, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      (Number(formData.value.sendReservation) === 0)
                        ? (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 0,
                            config: _unref(configMinDate),
                            class: "form-control",
                            disabled: ""
                          }, null, 8, ["config"]))
                        : _createCommentVNode("", true),
                      (Number(formData.value.sendReservation) === 1)
                        ? (_openBlock(), _createBlock(_unref(flatPickr), {
                            key: 1,
                            modelValue: _unref(v$).booking_date.$model,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(v$).booking_date.$model) = $event)),
                            config: _unref(configMinDate),
                            class: _normalizeClass(['form-control bg-white', _unref(bookingDateInvalid) ? 'is-invalid' : '']),
                            onChange: CheckTime
                          }, null, 8, ["modelValue", "config", "class"]))
                        : _createCommentVNode("", true),
                      _hoisted_87
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)(`OE50specify`),
                      params: [10],
                      validator: _unref(v$).booking_date.$errors[0]?.$validator
                    }, null, 8, ["title", "validator"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    (Number(formData.value.sendReservation) === 0)
                      ? (_openBlock(), _createElementBlock("select", _hoisted_90, _hoisted_92))
                      : _createCommentVNode("", true),
                    (Number(formData.value.sendReservation) === 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 1,
                          class: "form-select fs-7",
                          "aria-label": "Default select example hours",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.hours) = $event)),
                          onChange: CheckTime
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HOURS), (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_93))
                          }), 128))
                        ], 544)), [
                          [_vModelSelect, formData.value.hours]
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_94, _toDisplayString(_unref(translate)('hours')), 1),
                    (Number(formData.value.sendReservation) === 0)
                      ? (_openBlock(), _createElementBlock("select", _hoisted_95, _hoisted_97))
                      : _createCommentVNode("", true),
                    (Number(formData.value.sendReservation) === 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 3,
                          class: "form-select fs-7",
                          "aria-label": "Default select example",
                          onChange: CheckTime,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.minutes) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MINUTES), (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_98))
                          }), 128))
                        ], 544)), [
                          [_vModelSelect, formData.value.minutes]
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_99, _toDisplayString(_unref(translate)('minutes')), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("p", _hoisted_100, _toDisplayString(validateTime.value && !_unref(v$).booking_date.$error ? _unref(translate)('VALIDATE_CURRENT_DATE_TIME', '', [10]) : ''), 1),
              _createElementVNode("p", _hoisted_101, _toDisplayString(_unref(translate)('OE50text2')), 1),
              _createElementVNode("p", _hoisted_102, _toDisplayString(_unref(translate)('OE50text3')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("div", _hoisted_104, [
          _createVNode(Button, {
            title: _unref(translate)('back'),
            type: 'secondary',
            className: 'fw-bold',
            onClick: BackPreviousPage
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_105, [
          _createVNode(Button, {
            title: _unref(translate)('confirm'),
            type: 'secondary',
            className: 'fw-bold',
            onClick: onSubmit
          }, null, 8, ["title"])
        ])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_106, [
      _createElementVNode("div", _hoisted_107, [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("h5", _hoisted_110, _toDisplayString(_unref(translate)('OE50titleConfirm')), 1),
            _hoisted_111
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("h2", _hoisted_114, _toDisplayString(_unref(numberWithCommas)(_unref(listRecordSelected)?.length)) + "件のユーザを選択中", 1),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listRecordSelected), (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: user,
                        class: "d-flex p-2 display_management"
                      }, [
                        _createVNode(UserAliasIcon, {
                          userType: user?.user_type
                        }, null, 8, ["userType"]),
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("span", _hoisted_118, _toDisplayString(user.management_no), 1),
                          _createElementVNode("span", _hoisted_119, _toDisplayString(user.family_name) + " " + _toDisplayString(user.given_name), 1),
                          (_unref(route)?.query?.user_type !== '1')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString('(' + user.display_name + '' + ')'), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("h2", _hoisted_122, _toDisplayString(_unref(translate)('OE50messageContent')), 1),
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("label", _hoisted_124, _toDisplayString(_unref(translate)('title')), 1),
                  _createElementVNode("div", _hoisted_125, _toDisplayString(formData.value.title), 1)
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("label", _hoisted_127, _toDisplayString(_unref(translate)('content')), 1),
                  _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("div", {
                      class: "w-100",
                      innerHTML: formatContent(formData.value.content)
                    }, null, 8, _hoisted_129)
                  ])
                ]),
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("label", _hoisted_131, _toDisplayString(_unref(translate)('attachingFile')), 1),
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        id: "fileUrl1Id",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (clickFile(fileData1.value, fileName1.value))),
                        href: "javascript:void(0)"
                      }, _toDisplayString(fileName1.value), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        id: "fileUrl2Id",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (clickFile(fileData2.value, fileName2.value))),
                        href: "javascript:void(0)"
                      }, _toDisplayString(fileName2.value), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        id: "fileUrl3Id",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (clickFile(fileData3.value, fileName3.value))),
                        href: "javascript:void(0)"
                      }, _toDisplayString(fileName3.value), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("label", _hoisted_134, _toDisplayString(_unref(translate)('OE65sendMail')), 1),
                  _createElementVNode("div", _hoisted_135, _toDisplayString(Number(formData.value.destination) === 0 ? _unref(translate)('OE50personal') : _unref(translate)('OE50personalEmail')), 1)
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("label", _hoisted_137, _toDisplayString(_unref(translate)('OE50titleDate')), 1),
                  _createElementVNode("div", _hoisted_138, _toDisplayString(Number(formData.value.sendReservation) === 0 ? _unref(translate)('OE50immediate') : '') + " " + _toDisplayString(Number(formData.value.sendReservation) === 1 ? _unref(dayjs)(formData.value.booking_date).format('YYYY/MM/DD') + ' ' + formData.value.hours + ':' + formData.value.minutes : ''), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_139, _toDisplayString(_unref(translate)('OE50textConfirm')), 1),
            _createElementVNode("div", _hoisted_140, [
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("div", _hoisted_142, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    className: 'fw-bold'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _createVNode(Button, {
                    title: _unref(translate)('signUp'),
                    type: 'secondary',
                    className: 'fw-bold',
                    onClick: SubmitTemplate,
                    disabled: loadingSend.value,
                    loading: loadingSend.value
                  }, null, 8, ["title", "disabled", "loading"])
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_144, [
      _createElementVNode("div", _hoisted_145, [
        _createElementVNode("div", _hoisted_146, [
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("h5", _hoisted_148, _toDisplayString(_unref(translate)('OE50titleFinish')), 1)
          ]),
          (dataReturn.value?.data_failed?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                _createElementVNode("div", _hoisted_150, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataReturn.value?.data_failed, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mb-2 d-flex align-items-center",
                      key: index
                    }, [
                      _createVNode(UserAliasIcon, {
                        userType: _unref(route)?.query?.user_type === '1' ? 1 : 2
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", _hoisted_151, _toDisplayString(item?.management_no), 1),
                      _hoisted_152,
                      _createElementVNode("span", null, _toDisplayString(renderName(item?.management_no)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_153, _toDisplayString(_unref(translate)(hanldeErrorServer.value ? 'registeredFail' : 'registered')), 1),
          _createElementVNode("div", _hoisted_154, [
            _createVNode(Button, {
              title: _unref(buttonModalFinishTitle),
              onClick: handleModalFinishButton,
              type: 'secondary'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})